import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { PageLayoutTabs } from '@thinknet-gmbh/platform-common-ui';

import { useRouteQuery } from 'src/common/helpers';
import { ROUTES } from 'src/components/app/app-routes.constants';

import { SETTINGS_PAGES } from './settings.constants';
import { CompanyProfile } from './components/company-profile';
import { CompanyProfileEdit } from './components/company-profile/components/company-profile-edit';
// import { AbsenceReasons } from './components/company-settings-pages/absence-reasons';
import { DocumentsLabels } from './components/company-settings-pages/documents-labels';
import { Documents } from './components/company-settings-pages/documents';
import { EmailTemplates } from './components/company-settings-pages/email-templates';
import { PermissionGroup } from './components/permission-group';
import { EditPermissionGroup } from './components/permission-group/components/edit-permission-group';
import { getDefaultTab } from './settings.helpers';
import { EditDatevNumber } from './components/datev/components/edit-datev-number';
import { EmployeeDevelopment } from './components/employee-development';
import { HolidayManager } from './components/holiday-manager';
import { HolidayDetails } from './components/holiday-manager/components/holiday-details';
import { EmployeeQuestionnaireSettings } from './components/employee-questionnaire-settings';
import { PayrollAccountingSetting } from './components/payroll-accounting-setting';
import { HealthInsurance } from './components/health-insurance';
import { SalaryTypes } from './components/salary-types';
import { ProcessTemplates } from './components/process-templates';
import { DocumentImportPatterns } from './components/document-import-patterns';
import { Applications } from './components/applications';

const Settings: React.FC = () => {
  const { t } = useTranslation(['common', 'settings']);
  const navigate = useNavigate();
  const query = useRouteQuery();
  const type: string =  query.get('type') || '';
  const isHolidayPage: string = query.get('page') || '';

  return (
    <PageLayoutTabs
      pageTitle={t('common:labels.settings')}
      onTabChange={tab => navigate(`${ROUTES.settings}?type=${tab}`)}
      defaultTab={getDefaultTab(type)}
      elements={[
        {
          tab: t('settings:company.labels.companyProfile'),
          tabIndex: SETTINGS_PAGES.companyProfile,
          component:
            type === SETTINGS_PAGES.editCompanyProfile ? (
              <CompanyProfileEdit />
            ) : (
              <CompanyProfile />
            ),
        },
        // {
        //   tab: t('settings:companySettings.labels.absence'),
        //   tabIndex: SETTINGS_PAGES.absence,
        //   component: <AbsenceReasons />,
        // },
        {
          tab: t('settings:documentImporter.labels.documentImporter'),
          tabIndex: SETTINGS_PAGES.documentImport,
          component: <DocumentImportPatterns />,
        },
        {
          tab: t('settings:healthInsurance.labels.healthInsurance'),
          tabIndex: SETTINGS_PAGES.healthInsurance,
          component: <HealthInsurance />,
        },
        {
          tab: t('settings:salaryTypes.labels.salaryTypes'),
          tabIndex: SETTINGS_PAGES.salaryTypes,
          component: <SalaryTypes />,
        },
        {
          tab: t('common:labels.label'),
          tabIndex: SETTINGS_PAGES.documentsLabels,
          component: <DocumentsLabels />,
        },
        {
          tab: t('settings:documents.labels.documents'),
          tabIndex: SETTINGS_PAGES.documents,
          component: <Documents />,
        },
        {
          tab: t('common:labels.email'),
          tabIndex: SETTINGS_PAGES.emailTemplates,
          component: <EmailTemplates />,
        },
        {
          tab: t('settings:applications.labels.applications'),
          tabIndex: SETTINGS_PAGES.applications,
          component: <Applications />,
        },
        {
          tab: t('settings:processTemplates.labels.processTemplates'),
          tabIndex: SETTINGS_PAGES.processTemplates,
          component: <ProcessTemplates />,
        },
        {
          tab: t('common:labels.permissionGroups'),
          tabIndex: SETTINGS_PAGES.permissionGroup,
          component:
            type === SETTINGS_PAGES.permissionGroupsEdit ? (
              <EditPermissionGroup />
            ) : (
              <PermissionGroup />
            ),
        },
        {
          tab: t('settings:employeeDevelopment.labels.employeeDevelopment'),
          tabIndex: SETTINGS_PAGES.employeeDevelopment,
          component: <EmployeeDevelopment />,
        },
        {
          tab: t('payrollAccounting:labels.pageTitle'),
          tabIndex: SETTINGS_PAGES.payrollAccounting,
          component:
            type === SETTINGS_PAGES.editDatev || type === SETTINGS_PAGES.editConsultantNumber ? (
              <EditDatevNumber />
            ) : (
              <PayrollAccountingSetting />
            ),
        },
        {
          tab: 'Holiday manager',
          tabIndex: SETTINGS_PAGES.holidayManager,
          component: !isHolidayPage ? <HolidayManager /> : <HolidayDetails />,
        },
        {
          tab: t('settings:employeeQuestionnaire.labels.employeeQuestionnaire'),
          tabIndex: SETTINGS_PAGES.employeeQuestionnaire,
          component: <EmployeeQuestionnaireSettings />,
        },
      ]}
    />
  );
};

export default Settings;
